class MainCart extends HTMLElement {
  constructor() {
    super();
    this.increaseQuantity = this.increaseQuantity.bind(this);
    this.decreaseQuantity = this.decreaseQuantity.bind(this);
    this.manualQuantity = this.manualQuantity.bind(this);

    this.handleProductRemoval = this.handleProductRemoval.bind(this);
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get sectionsToUpdate() {
    return this.dataset.sectionsToUpdate
      ? this.dataset.sectionsToUpdate.split(",").map((s) => `.${s.trim()}`)
      : [];
  }

  get caskStorageVariantId() {
    const id = parseInt(this.dataset.caskStorageVariantId);
    return id || null;
  }

  connectedCallback() {
    this.bindEvents()
  }

  bindEvents() {
    // quantity changers
    this.quantityWrapper = this.querySelectorAll(
      ".bosCartItemActionsQuantity",
    );
    if (this.quantityWrapper.length > 0) {
      this.quantityWrapper.forEach((wrapper) => {
        const input = wrapper.querySelector(
          ".bosCartItemActionsQuantityInput",
        );
        if (!input) return;

        // manual input
        input.addEventListener("change", () =>
          this.manualQuantity(wrapper, input),
        );

        // decrease button
        const minus = wrapper.querySelector(
          ".bosCartItemActionsQuantityDecrease",
        );
        if (minus) {
          minus.addEventListener("click", () =>
            this.decreaseQuantity(wrapper, input),
          );
        }
        // increase button
        const plus = wrapper.querySelector(
          ".bosCartItemActionsQuantityIncrease",
        );
        if (plus) {
          plus.addEventListener("click", () =>
            this.increaseQuantity(wrapper, input),
          );
        }
      });
    }

    // remove button
    this.removeButton = this.querySelectorAll(
      ".bosCartItemActionsRemove",
    );
    if (this.removeButton.length > 0) {
      this.removeButton.forEach((btn) =>
        btn.addEventListener("click", this.handleProductRemoval),
      );
    }
  }

  calculateStorageTotals() {
    const totals = {};
    if (this.caskStorageVariantId) {
      totals[this.caskStorageVariantId] = 0;
    }
    this.querySelectorAll(
      ".bosCartItemActionsQuantity[data-storage-variant-id]",
    ).forEach((wrapper) => {
      const storageVariantId = parseInt(wrapper.dataset.storageVariantId);
      if (!storageVariantId) return;
      const input = wrapper.querySelector(
        ".bosCartItemActionsQuantityInput",
      );
      const qty = input ? parseInt(input.value) || 0 : 0;
      totals[storageVariantId] = (totals[storageVariantId] || 0) + qty;
    });
    return totals;
  }

  decreaseQuantity(wrapper, input) {
    const newQty = parseInt(input.value) - 1;
    const productId = parseInt(input.dataset.productId);

    if (newQty <= 0) {
      wrapper.closest(".bosCartItem")?.remove();
      this.handleCartUpdates({
        [productId]: 0,
        ...this.calculateStorageTotals(),
      });
    } else {
      input.value = newQty;
      this.handleCartUpdates({
        [productId]: newQty,
        ...this.calculateStorageTotals(),
      });
    }
  }

  increaseQuantity(wrapper, input) {
    input.value = parseInt(input.value) + 1;
    const productId = parseInt(input.dataset.productId);
    this.handleCartUpdates({
      [productId]: parseInt(input.value),
      ...this.calculateStorageTotals(),
    });
  }

  manualQuantity(wrapper, input) {
    const newQty = parseInt(input.value);
    const productId = parseInt(input.dataset.productId);

    if (isNaN(newQty) || newQty <= 0) {
      wrapper.closest(".bosCartItem")?.remove();
      this.handleCartUpdates({
        [productId]: 0,
        ...this.calculateStorageTotals(),
      });
    } else {
      input.value = newQty;
      this.handleCartUpdates({
        [productId]: newQty,
        ...this.calculateStorageTotals(),
      });
    }
  }

  handleProductRemoval(e) {
    const target = e.currentTarget;
    if (!target) return;
    const productId = parseInt(target.dataset.productId);
    if (!productId) return;
    target.closest(".bosCartItem")?.remove();
    this.handleCartUpdates({
      [productId]: 0,
      ...this.calculateStorageTotals(),
    });
  }

  renderSection(html, selectors) {
    const temp = document.createElement("div");
    temp.innerHTML = html;

    selectors.forEach((selector) => {
      const target = document.querySelector(selector);
      const source = temp.querySelector(selector);
      if (!target || !source) {
        console.warn("renderSection: selector not found", selector);
        return;
      }
      target.innerHTML = source.innerHTML;
    });
  }

  handleCartUpdates(updates) {
    if (!updates || Object.keys(updates).length === 0) return;

    const url = new URL(
      window.location.origin + window.Shopify.routes.root + "cart/update.js",
    );

    const sections = this.sectionId;
    if (!sections) return;
    url.searchParams.set("sections", sections);

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ updates }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data?.sections && this.sectionId && this.sectionsToUpdate) {
          this.renderSection(
            data.sections[this.sectionId],
            this.sectionsToUpdate,
          );
          this.bindEvents();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

if (!customElements.get("main-cart")) {
  customElements.define("main-cart", MainCart);
}